/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Md_CopiedInputs */

const en_md_copied = /** @type {(inputs: Md_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const id_md_copied = /** @type {(inputs: Md_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersalin`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Md_CopiedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const md_copied = /** @type {((inputs?: Md_CopiedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Md_CopiedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_md_copied(inputs)
	return en_md_copied(inputs)
});